<template>
  <v-speed-dial v-model="active" :direction="direction" :open-on-hover="false" style="float: right; z-index: 1">
    <template v-slot:activator>
      <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.options')">
        <v-btn v-model="active" color="green" dark small v-on="on">
          <v-icon>{{ active ? 'close' : 'menu_open' }}</v-icon>
        </v-btn>
      </Tooltip>
    </template>
    <FormSettings></FormSettings>
    <Upload/>

    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.last_user_form')">
      <v-btn :color="byUser ? 'orange' : ''" @click="$emit('byUser')" v-on="on">
        <v-icon block fab small>person</v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.kanban')">
      <v-btn v-if="kanbanEnabled()" @click="goToKanban()" v-on="on">
        <v-icon block color="red darken-3" fab small style="color: #efefef">view_kanban</v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.print_all')">
      <v-btn @click="$emit('print')" v-on="on">
        <v-icon :disabled="!docAvailable" block color="blue-grey darken-2" fab small style="color: #efefef">print
        </v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.confirm_all')">
      <v-btn @click="$emit('confirmAll')" v-on="on">
        <v-icon block color="orange darken-4" fab small style="color: #efefef">check</v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.csv_export')">
      <v-btn @click="$emit('printAllCsv')" v-on="on">
        <v-icon block color="green darken-3" fab small style="color: #efefef">receipt</v-icon>
      </v-btn>
    </Tooltip>
  </v-speed-dial>
</template>

<script>

import Tooltip from "@/components/common/Tooltip.vue"
import Upload from "@/components/form/Upload.vue"
import FormSettings from "@/components/form/FormSettings.vue"

const MIN_SCREEN_WIDTH = 800
export default {
  components: {FormSettings, Upload, Tooltip},
  props: ['docAvailable', 'byUser'],
  data() {
    return {
      active: false
    }
  },
  computed: {
    direction() {
      return window.screen.width < MIN_SCREEN_WIDTH ? 'bottom' : 'left'
    }
  },
  methods: {
    goToKanban() {
      this.$router.push('/form/' + this.$route.params.schemaId + '/kanban')
    },
    kanbanEnabled() {
      let schema = this.$store.state.forms.schema
      return !!schema && !!schema.kanban && schema.kanban.length > 0
    }
  }
}
</script>


<style scoped>

</style>